import InputAutocomplete from '@components/InputAutocomplete';
import { FormGroup, FormLabel } from '@mui/material';
import { ITalentSearchFilterOption } from '../types';

interface ProfessionFilterProps {
  name: string;
  options: ITalentSearchFilterOption[];
}

const ProfessionFilter = ({ name, options }: ProfessionFilterProps) => {
  const mappedOptions = options.map((option) => ({
    value: option.value,
    label: `${option.label} (${option.count})`,
    groupLabel: option.groupLabel,
  }));

  return (
    <FormGroup>
      <FormLabel>Métier</FormLabel>
      <InputAutocomplete
        id={name}
        name={name}
        multiple
        groupBy={(option: any) => option.groupLabel}
        options={mappedOptions}
      />
    </FormGroup>
  );
};

export default ProfessionFilter;
